import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';
import ContentList from './content-list';
import EditList from './edit-list';
import {toast} from 'react-toastify';

const MngLists = ({playlistStore}) => {
    const [editingList, setEditingList] = useState(false);
    const [currentItem, setCurrentItem] = useState({});
    const [addMenuOpen, setAddMenuOpen] = useState(false);
    const [addListType, setAddListType] = useState('SONG');
    const [pendingAddType, setPendingAddType] = useState(null);
    const [pendingCancel, setPendingCancel] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(false);
    const [discardModalOpen, setDiscardModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [listMode, setListMode] = useState("CREATE");
    const [orderDirty, setOrderDirty] = useState(false);
    const [orderedListItems, setOrderedListItems] = useState([]);
    const addMenuRef = useRef(null);

    const listTypeOptions = [
        { key: 'SONG', label: 'Song' },
        { key: 'ARTIST', label: 'Artist' },
        { key: 'ALBUM', label: 'Album' },
        { key: 'FEATURED', label: 'Featured' },
    ];

    const toggleAddMenu = () => {
        setAddMenuOpen((prev) => !prev);
    }

    const openPlaylist = (item) => {
        setCurrentItem(item);
        setAddListType(item.listType);
        setListMode("EDIT");
        setEditingList(true);
    }

    const onSelectListType = (type) => {
        if (editingList) {
            setPendingAddType(type);
            setDiscardModalOpen(true);
            setAddMenuOpen(false);
            return;
        }

        const playlist = playlistStore.data.playlist.toPOJO();
        setCurrentItem(playlist);
        setAddListType(type);
        setEditingList(true);
        setAddMenuOpen(false);
    }

    const confirmDiscard = () => {
        if (pendingAddType) {
            const playlist = playlistStore.data.playlist.toPOJO();
            setCurrentItem(playlist);
            setAddListType(pendingAddType);
            setEditingList(true);
            setPendingAddType(null);
            setDiscardModalOpen(false);
            setAddMenuOpen(false);
        }

        else if(pendingCancel) {
            setPendingCancel(false);
            setCurrentItem({});
            setEditingList(false);
            setDiscardModalOpen(false);
            setAddMenuOpen(false);
        }
    }

    const cancelDiscard = () => {
        setPendingAddType(null);
        setDiscardModalOpen(false);
    }

    const confirmDelete = () => {
        if(pendingDelete) {
            playlistStore.deletePlaylist(currentItem);
            setCurrentItem({});
            setPendingDelete(false);
            setDeleteModalOpen(false);
            setEditingList(false);
            toast.success("List deleted successfully");
        }
    }

    const cancelDelete = () => {
        setPendingDelete(false);
        setDeleteModalOpen(false);
    }

    const handleSave = (listTitle, listType, selectedItems) => {
            // BUG FIX: previously this handler ALWAYS called savePlaylist()
            // (which POSTs to /api/playlists/create), even in EDIT mode —
            // producing a duplicate playlist on every save of an existing
            // list. Branch on listMode + currentItem._id and route to
            // updatePlaylist (PUT /api/playlists/:id) when editing.
            if (listMode === "EDIT" && currentItem?._id) {
                playlistStore.updatePlaylist({
                    _id: currentItem._id,
                    title: listTitle,
                    listType: listType.toUpperCase(),
                    itemIDs: selectedItems,
                    showOnFrontPage: true,
                });
            } else {
                playlistStore.data.playlist.set('title', listTitle);
                playlistStore.data.playlist.set('listType', listType.toUpperCase());
                playlistStore.data.playlist.set('itemIDs', selectedItems);
                playlistStore.data.playlist.set('showOnFrontPage', true);
                playlistStore.data.playlist.set('position', playlistStore.items.length);
                playlistStore.savePlaylist();
            }

            setCurrentItem({});
            setEditingList(false);
            toast.success("List saved successfully");
    }
    
    const onDeleteClick = () => {
        setPendingDelete(true);
        setDeleteModalOpen(true);
    }

    const onOrderChange = (items) => {
        setOrderedListItems(items);
        setOrderDirty(true);
    };

    const handleSaveOrder = async () => {
        if (!orderDirty || orderedListItems.length === 0) {
            return;
        }

        try {
            await playlistStore.savePlaylistOrder(orderedListItems);
            setOrderDirty(false);
        } catch (err) {
            console.error('[ERROR] Save playlist order failed', err);
        }
    };

    const onCancelClick = () => {
        if(editingList) {
            setPendingCancel(true);
            setDiscardModalOpen(true);
            return;
        }
        
    }

    useEffect(() => {
        if (!addMenuOpen) {
            return;
        }

        const handleClickOutside = (event) => {
            if (addMenuRef.current && !addMenuRef.current.contains(event.target)) {
                setAddMenuOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [addMenuOpen]);

    return (
        <div className="grid-x grid-padding-x padding-top-1 padding-left-1" style={ {height: '100%'} }>
            {!editingList && (
                <div className="cell small-4 padding-left-1">
                    <h3>Manage Lists</h3>
                    <div ref={addMenuRef} style={{ position: 'relative', display: 'inline-block' }}>
                        <button className="button neo card" onClick={toggleAddMenu}>Add List</button>
                        {!addMenuOpen && orderDirty && (
                            <button
                                type="button"
                                className="button neo card"
                                onClick={handleSaveOrder}
                            >
                                Save List Order
                            </button>
                        )}
                        {addMenuOpen && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                            left: '100%',
                            marginLeft: 8,
                            background: '#333333',
                            color: '#fff',
                            border: '1px solid rgba(0,0,0,0.12)',
                            boxShadow: '0 12px 24px rgba(0,0,0,0.16)',
                            zIndex: 10,
                            minWidth: 150,
                        }}>
                            {listTypeOptions.map((option) => (
                                <button
                                    key={option.key}
                                    type="button"
                                    className="button ghost"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'left',
                                        padding: '10px 12px',
                                        border: 'none',
                                        background: 'transparent',
                                        fontSize: 16,
                                        color: '#fff',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => onSelectListType(option.key)}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
                <ContentList playlistStore={playlistStore} clickHandler={openPlaylist} onOrderChange={onOrderChange} />
                
            </div>)}
            <div className="cell small-12">
                {editingList && (<EditList playlistStore={playlistStore} editItem={currentItem} onSaveList={handleSave} onCancel={onCancelClick} onDelete={onDeleteClick} listType={addListType} listLabel={listTypeOptions[addListType]} listMode={listMode}/>)}
            </div>
            
            {discardModalOpen && (
                    <div style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.35)',
                        zIndex: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            background: '#fff',
                            border: '1px solid #000',
                            padding: 24,
                            maxWidth: 400,
                            width: '100%',
                            boxSizing: 'border-box',
                        }}>
                            <p style={{ margin: 0, marginBottom: 20, color: '#000' }}>
                                You have unsaved changes, do you really want to discard them?
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                                <button className="button neo card" type="button" onClick={cancelDiscard}>No</button>
                                <button className="button neo card" type="button" onClick={confirmDiscard}>Yes</button>
                            </div>
                        </div>
                    </div>
            )}
            
            {deleteModalOpen && (
                    <div style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.35)',
                        zIndex: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            background: '#fff',
                            border: '1px solid #000',
                            padding: 24,
                            maxWidth: 400,
                            width: '100%',
                            boxSizing: 'border-box',
                        }}>
                            <p style={{ margin: 0, marginBottom: 20, color: '#000' }}>
                                Are you sure you want to delete this list?
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                                <button className="button neo card" type="button" onClick={cancelDelete}>No</button>
                                <button className="button neo card" type="button" onClick={confirmDelete}>Yes</button>
                            </div>
                        </div>
                    </div>
            )}
        </div>
    )
}

const injectWithStores = inject('playlistStore');

export default injectWithStores(
    ({playlistStore}) => {
        return (
            <MngLists playlistStore={playlistStore} />
        )
    })